import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BotonTipo } from '../../../components/boton/boton';
import { TipoABM } from '../../../interfaces/tipo-abm';
import { OtComponent } from '../ot.component';
import { MatDialog } from '@angular/material';
import { OT } from '../../../interfaces/ot';

@Component({
  selector: 'app-guardar-ot',
  templateUrl: './guardar-ot.component.html',
  styleUrls: ['./guardar-ot.component.scss']
})
export class GuardarOtComponent implements OnInit {
  TipoABM: TipoABM = new TipoABM();
  @Input() tipoABM: string;
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';
  @Input() element: any;
  _boton_icono: string;
  _boton_texto: string;
  _boton_color: string;
  titulo: string = 'OT';
  @Output() onSubmitted = new EventEmitter<any>();

  _disabled: boolean;
  @Input() public set disabled(v: boolean) {
    this._disabled = v;
  }
  public get disabled(): boolean {
    return this._disabled;
  }

  constructor(
    private _dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.tipoABM) {
      throw "La variable Input 'tipoABM' es requerida";
    }
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }

    this._preprararBoton();
  }

  private _preprararBoton() {
    switch (this.tipoABM) {
      case this.TipoABM.ALTA:
        this._boton_icono = "add";
        this._boton_texto = "Crear " + this.titulo;
        this._boton_color = "accent";
        break;
      case this.TipoABM.BAJA:
        this._boton_icono = "clear";
        this._boton_texto = "Eliminar " + this.titulo;
        this._boton_color = "warn";
        break;
      case this.TipoABM.MODIFICACION:
        if (!this.element) {
          throw "La variable Input 'element' es requerida";
        }
        this._boton_icono = "edit";
        this._boton_texto = "Editar " + this.titulo;
        this._boton_color = "accent";
        break;
      default:
        throw "La variable Input 'tipoABM' debe ser un valor de 'TipoABM'";
    }
  }

  guardar() {
    switch (this.tipoABM) {
      case this.TipoABM.ALTA:
        this.formModal(<OT>{
          id: null
        });
        break;
      case this.TipoABM.BAJA:
        break;
      case this.TipoABM.MODIFICACION:
        this.formModal(this.element);
        break;
    }
  }

  formModal(model: any) {
    this._dialog.open(OtComponent, {
      disableClose: true,
      minWidth: '840px',
      data: {
        tipoABM: this.tipoABM,
        titulo: this.titulo,
        model: model
      }
    }).afterClosed().subscribe((respuesta) => {
      this.onSubmitted.emit(respuesta);
    });
  }
}
